<template>
  <base-nav class="navbar-top navbar-dark" id="navbar-main" :show-toggle-button="false" expand>
    <form class="navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto"></form>
    <ul class="navbar-nav align-items-center d-none d-md-flex" v-if="isOwner">
      <li class="nav-item dropdown">
        <base-dropdown class="nav-link pr-0">
          <div class="media align-items-center" slot="title">
            <div class="media-body ml-2 d-none d-lg-block">
              <span
                class="mb-0 text-sm font-weight-bold"
              >Organization: {{$store.state.usermain.curOrg.name}}</span>
            </div>
          </div>

          <template>
            <div class="dropdown-header noti-title">
              <h6 class="text-overflow m-0">Select one to view</h6>
            </div>
            <div @click="selectOrg({'name': 'None', 'type': 'None'})" class="dropdown-item">
              <span>None</span>
            </div>
            <!--<div
              @click="selectOrg(organization)"
              v-for="organization in organizations"
              v-bind:key="organization.id"
              class="dropdown-item"
            >
              <span>{{organization.name}}</span>
            </div>-->
          </template>
        </base-dropdown>
      </li>
    </ul>
    <span
      v-else
      class="text-white text-sm font-weight-bold"
    >Organization: {{$store.state.usermain.curOrg.name}}</span>

    <ul class="navbar-nav align-items-center d-none d-md-flex">
      <li class="nav-item dropdown">
        <base-dropdown class="nav-link pr-0">
          <div class="media align-items-center" slot="title">
            <span class="avatar avatar-sm rounded-circle">
              <img alt="Img" :src="currentUser.photoURL" />
            </span>
            <div class="media-body ml-2 d-none d-lg-block">
              <span class="mb-0 text-sm font-weight-bold">{{currentUser.displayName}}</span>
            </div>
          </div>

          <template>
            <div class="dropdown-header noti-title">
              <h6 class="text-overflow m-0">Welcome!</h6>
            </div>
            <router-link to="/profile" class="dropdown-item">
              <i class="ni ni-single-02"></i>
              <span>My profile</span>
            </router-link>
            <div class="dropdown-divider"></div>
            <button @click="logout" class="dropdown-item">
              <i class="ni ni-user-run"></i>
              <span>Logout</span>
            </button>
          </template>
        </base-dropdown>
      </li>
    </ul>
  </base-nav>
</template>
<script>
import firebase from "../config/firebase.js";
import { bus } from "../main";

export default {
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      searchQuery: "",
      organizations: []
    };
  },
  mounted: function() {
    this.userData();
  },
  created: function() {
    this.userData();
  },
  updated: function() {
    this.userData();
  },
  computed: {
    currentUser() {
      return this.$store.state.usermain.currentUser;
    },
    isOwner() {
      return this.$store.state.usermain.isOwner;
    }
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    selectOrg(organization) {
      console.log(organization);

      this.$store.commit("setCurOrg", organization);
    },
    userData: function() {
      const self = this;

      if (this.isOwner) {
        firebase
          .firestore()
          .collection("organizations/")
          .get()
          .then(function(querySnapshot) {
            const documents = querySnapshot.docs.map(doc => {
              const docData = doc.data();
              docData.id = doc.id;

              return docData;
            });

            self.organizations = documents;
          });
      }
    },
    logout: function() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.replace("login");
        });
    }
  }
};
</script>
